import React, { useState, memo } from 'react';
import { Heart, Star, Send, Check } from 'lucide-react';
type Comment = {
  username: string;
  stars: number;
  text: string;
  likes: number;
  time: string;
};
const initialComments: Comment[] = [{
  username: '@maria_enfermeria_bsas',
  stars: 5,
  text: 'Apliqué el plan de 14 días desde la primera semana. Ahorro más de 8 horas por semana de estudio desorganizado. Vale cada centavo.',
  likes: 47,
  time: 'Hace 3 horas'
}, {
  username: '@lucas_medicina_cba',
  stars: 5,
  text: 'En dos semanas reduje mi tiempo de preparación un 80% sin cambiar mi método de estudio. Solo con los checklists fue suficiente.',
  likes: 32,
  time: 'Hace 5 horas'
}, {
  username: '@valentina_fisio_bog',
  stars: 5,
  text: 'La autoevaluación me abrió los ojos. Nunca antes tuve un sistema tan claro para saber qué me faltaba repasar.',
  likes: 28,
  time: 'Hace 8 horas'
}, {
  username: '@camila_kinesio_mdp',
  stars: 4,
  text: 'Hay muchísimo material. Al principio pensé que no iba a usar todo pero después de organizarme cada página tiene sentido.',
  likes: 19,
  time: 'Hace 12 horas'
}, {
  username: '@diego_nutricion_ros',
  stars: 5,
  text: 'Las fichas de memorización rápida me salvaron la víspera del examen. Antes cada día de examen era puro caos.',
  likes: 24,
  time: 'Ayer'
}];
const morePool: Comment[] = [{
  username: '@sofia_odonto_mex',
  stars: 5,
  text: 'El mapa maestro de anatomía me cambió la forma de ver el cuerpo. Por fin entiendo cómo se conectan los sistemas.',
  likes: 38,
  time: 'Hace 1 día'
}, {
  username: '@joaquin_med_scl',
  stars: 5,
  text: 'Aprobé anatomía con 9 después de venir arrastrando la materia. Las 291 preguntas de autoevaluación son oro puro.',
  likes: 52,
  time: 'Hace 1 día'
}, {
  username: '@isabella_enf_med',
  stars: 5,
  text: 'Lo recomendé a toda mi cohorte. Es increíble que algo tan completo cueste menos que un libro de texto.',
  likes: 41,
  time: 'Hace 1 día'
}, {
  username: '@martina_fisio_uio',
  stars: 5,
  text: 'La guía express de términos anatómicos me salvó el primer parcial. Tener los prefijos y sufijos juntos es genial.',
  likes: 29,
  time: 'Hace 1 día'
}, {
  username: '@tomas_kin_mvd',
  stars: 4,
  text: 'Muy práctico, directo, nada de relleno. Para por fin tener un método de estudio claro vale todo.',
  likes: 16,
  time: 'Hace 2 días'
}, {
  username: '@agustina_med_lim',
  stars: 5,
  text: 'Pensé que era demasiado bueno para ser verdad. Lo uso hace 3 semanas y mis notas mejoraron de 6 a 9. Increíble.',
  likes: 56,
  time: 'Hace 2 días'
}, {
  username: '@nicolas_nutri_bog',
  stars: 5,
  text: 'Las 25 fichas visuales son perfectas para el repaso de último minuto. Llego a los exámenes con todo fresco.',
  likes: 33,
  time: 'Hace 2 días'
}, {
  username: '@florencia_enf_mdz',
  stars: 5,
  text: 'El checklist por sistemas me dio confianza real. Nunca más voy a llegar al examen con la duda de si me faltó algo.',
  likes: 27,
  time: 'Hace 2 días'
}, {
  username: '@pablo_med_qro',
  stars: 4,
  text: 'Genial el sistema de 4 niveles de dominio. Me ayuda a saber dónde tengo que poner más esfuerzo cada semana.',
  likes: 14,
  time: 'Hace 2 días'
}, {
  username: '@josefina_odo_san',
  stars: 5,
  text: 'Para estudiantes latinos no había algo así. Es el recurso que faltaba. Lo voy a usar toda la carrera.',
  likes: 44,
  time: 'Hace 3 días'
}];
const StarRating = ({
  value,
  onChange,
  size = 'w-7 h-7',
  interactive = false
}: {
  value: number;
  onChange?: (v: number) => void;
  size?: string;
  interactive?: boolean;
}) => <div className="flex items-center gap-1" data-id="element-223">
    {[1, 2, 3, 4, 5].map(i => <button key={i} type="button" onClick={() => interactive && onChange?.(i)} disabled={!interactive} aria-label={`${i} estrellas`} className={`${interactive ? 'cursor-pointer hover:scale-110 transition-transform' : 'cursor-default'} ${i <= value ? 'text-amber-400' : 'text-ink-300'}`} data-id="element-224">
        <Star className={`${size} ${i <= value ? 'fill-current' : ''}`} data-id="element-225" />
      </button>)}
  </div>;
export function CommentsSection() {
  const [text, setText] = useState('');
  const [name, setName] = useState('');
  const [rating, setRating] = useState(0);
  const [submitted, setSubmitted] = useState(false);
  const [visibleCount, setVisibleCount] = useState(5);
  const [extraComments, setExtraComments] = useState<Comment[]>([]);
  const [likedSet, setLikedSet] = useState<Set<string>>(new Set());
  const allComments = [...initialComments, ...extraComments];
  const visible = allComments.slice(0, visibleCount);
  const canLoadMore = visibleCount < initialComments.length + morePool.length;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!text.trim() || rating === 0) return;
    setSubmitted(true);
    setText('');
    setName('');
    setRating(0);
    setTimeout(() => setSubmitted(false), 5000);
  };
  const handleLoadMore = () => {
    const start = extraComments.length;
    const next = morePool.slice(start, start + 5);
    setExtraComments([...extraComments, ...next]);
    setVisibleCount(visibleCount + 5);
  };
  const toggleLike = (username: string) => {
    setLikedSet(prev => {
      const next = new Set(prev);
      if (next.has(username)) next.delete(username);else next.add(username);
      return next;
    });
  };
  return <section className="py-16 md:py-20 bg-mist" data-id="element-226">
      <div className="max-w-3xl mx-auto px-4" data-id="element-227">
        <div className="text-center mb-10" data-id="element-228">
          <p className="text-cyan-600 font-bold text-sm uppercase tracking-widest mb-2" data-id="element-229">
            Comunidad
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-3" data-id="element-230">
            Opiniones de estudiantes
          </h2>
          <p className="text-ink-500" data-id="element-231">
            Más de 800 estudiantes ya cambiaron su forma de estudiar anatomía
          </p>
        </div>

        <div className="card-premium p-6 md:p-8 mb-8 relative" data-id="element-232">
          {submitted && <div className="absolute inset-0 z-20 flex items-center justify-center bg-white/95 backdrop-blur-sm rounded-[20px] border border-emerald-500/30 p-6" data-id="element-233">
              <div className="text-center" data-id="element-234">
                <div className="w-16 h-16 rounded-full bg-emerald-500/15 border border-emerald-500/40 flex items-center justify-center mx-auto mb-4" data-id="element-235">
                  <Check className="w-8 h-8 text-emerald-600" data-id="element-236" />
                </div>
                <h3 className="text-xl font-bold text-navy-900 mb-2" data-id="element-237">
                  ¡Gracias por tu comentario!
                </h3>
                <p className="text-ink-500 max-w-sm mx-auto" data-id="element-238">
                  Tu reseña será publicada en breve después de la moderación.
                </p>
              </div>
            </div>}

          <form onSubmit={handleSubmit} className="space-y-5" data-id="element-239">
            <div data-id="element-240">
              <label className="block text-navy-900 font-bold mb-3 text-sm" data-id="element-241">
                Dejá tu reseña para la comunidad
              </label>
              <textarea value={text} onChange={e => setText(e.target.value)} placeholder="Escribí tu experiencia con el Mega Pack..." rows={4} className="w-full bg-white border border-navy-100 rounded-xl p-4 text-navy-900 placeholder-ink-300 focus:outline-none focus:border-cyan-500 focus:ring-2 focus:ring-cyan-500/20 transition-colors resize-none text-sm" required data-id="element-242" />
            </div>

            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-243">
              <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Tu nombre (opcional)" className="flex-1 bg-white border border-navy-100 rounded-xl px-4 py-3 text-navy-900 placeholder-ink-300 focus:outline-none focus:border-cyan-500 focus:ring-2 focus:ring-cyan-500/20 transition-colors text-sm" data-id="element-244" />
              <div className="flex items-center gap-3" data-id="element-245">
                <span className="text-ink-500 text-sm font-medium" data-id="element-246">
                  Calificá:
                </span>
                <StarRating value={rating} onChange={setRating} interactive size="w-6 h-6" data-id="element-247" />
              </div>
            </div>

            <button type="submit" disabled={!text.trim() || rating === 0} className="btn-primary w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 rounded-xl text-sm uppercase tracking-wider disabled:opacity-40 disabled:cursor-not-allowed" data-id="element-248">
              <Send className="w-4 h-4" data-id="element-249" />
              Publicar
            </button>
          </form>
        </div>

        <div className="space-y-4" data-id="element-250">
          {visible.map((c, i) => {
          const liked = likedSet.has(c.username);
          const likeCount = c.likes + (liked ? 1 : 0);
          return <div key={`${c.username}-${i}`} className="card-premium p-5 md:p-6" data-id="element-251">
                <div className="flex items-start justify-between gap-3 mb-2" data-id="element-252">
                  <div className="flex items-center gap-3 min-w-0" data-id="element-253">
                    <div className="w-10 h-10 rounded-full bg-cyan-500/10 border border-cyan-500/30 flex items-center justify-center text-cyan-600 font-bold shrink-0" data-id="element-254">
                      {c.username.charAt(1).toUpperCase()}
                    </div>
                    <span className="text-navy-900 font-bold truncate text-sm" data-id="element-255">
                      {c.username}
                    </span>
                  </div>
                  <StarRating value={c.stars} size="w-4 h-4" data-id="element-256" />
                </div>

                <p className="text-ink-700 leading-relaxed mb-3 text-[15px]" data-id="element-257">
                  {c.text}
                </p>

                <div className="flex items-center gap-5 text-sm" data-id="element-258">
                  <button onClick={() => toggleLike(c.username)} className={`flex items-center gap-1.5 transition-colors ${liked ? 'text-red-500' : 'text-ink-400 hover:text-ink-700'}`} aria-label={liked ? 'Quitar me gusta' : 'Dar me gusta'} data-id="element-259">
                    <Heart className={`w-4 h-4 ${liked ? 'fill-current' : ''}`} data-id="element-260" />
                    <span className="font-medium" data-id="element-261">{likeCount}</span>
                  </button>
                  <span className="text-ink-400 text-xs" data-id="element-262">{c.time}</span>
                </div>
              </div>;
        })}

          {canLoadMore && <div className="flex justify-center pt-4" data-id="element-263">
              <button onClick={handleLoadMore} className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-white border border-navy-100 hover:border-cyan-500/50 text-navy-900 font-semibold transition-colors" data-id="element-264">
                Cargar 5 comentarios más
              </button>
            </div>}
        </div>
      </div>
    </section>;
}